import store from '@/store';

import { langBus } from './index';
import { syncLanguage } from '@/api/auth';
import { getToken } from '@/utils/utils';

/** 注册语言切换钩子 */
export function registryLangHook() {
  langBus.on(() => {
    if (!getToken()) return;
    store.dispatch('admin/updateDeviceModel');

    syncLanguage();
  });
}
